import React, { useState } from 'react'
import {
    Button,
    DialogContent,
    Typography,
    AppBar,
    Toolbar,
    useTheme,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { GetUpsertIcon, IsNotNullOrUndefined } from '../Helpers';
import IconButtonEx, { IconButtonExProps } from '../components/IconButtonEx';
import { UpsertAction } from '../Enums';
import ButtonEx from '../components/ButtonEx';
import { ResponsiveDialog, ResponsiveDialogHeader, StickyDialogActions } from '../components/responsive';
import useViewportMode from '../hooks/useViewportMode';

export interface DisplayDialogProps extends Omit<IconButtonExProps, 'onClick'> {
    title?: string;
    fullWidth?: boolean;
    mode: UpsertAction;
    content?: (() => JSX.Element) | JSX.Element;
    busy: boolean;
    icon?: JSX.Element;
    onClose?: () => Promise<void> | void;
};

let displayDialogId = 0;

const DisplayDialogContent = ({ title, fullWidth, mode, content, busy, onClose = async () => { }, icon = GetUpsertIcon(mode), ...btnProps }: DisplayDialogProps) => {

    const [open, setOpen] = useState<boolean>(false);
    const theme = useTheme();
    const viewport = useViewportMode();
    const [titleId] = useState(() => `display-dialog-title-${++displayDialogId}`);

    const disableSave = () => {
        if (mode === UpsertAction.Create) {
            return true;
        }
        else {
            return true; 
        }
    }

    const handleClose = () => {
        if (IsNotNullOrUndefined(onClose))
            onClose();

        setOpen(false);
    };

    const handleSubmit = async () => {
        setOpen(false);
    };

    const dialogContent = content instanceof Function ? content() : content;

    return (
        <>
            <IconButtonEx disabled={busy} hoverContent={title ?? ''} size='small' onClick={() => setOpen(true)} {...btnProps}>{icon}</IconButtonEx>

            <ResponsiveDialog aria-labelledby={titleId} open={open} fullWidth={fullWidth ?? true} maxWidth="xl" tabletFullScreen="portrait">
                {viewport.isDesktop ? (
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButtonEx edge="start" color="inherit" onClick={handleClose} aria-label="close"><CloseIcon /></IconButtonEx>
                            <Typography id={titleId} sx={{ marginLeft: theme.spacing(2), fontSize: 'x-large', flex: 1 }}>{title}</Typography>
                            <ButtonEx autoFocus color="inherit" onClick={handleClose}>close</ButtonEx>
                        </Toolbar>
                    </AppBar>
                ) : (
                    <ResponsiveDialogHeader id={titleId} title={title ?? ''} onClose={handleClose} />
                )}
                <DialogContent dividers sx={{ minHeight: 0, overflowY: 'auto', padding: viewport.isPhone ? 1 : theme.spacing(2) }}>
                    {dialogContent}
                </DialogContent>
                <StickyDialogActions phoneLayout="stacked" sx={{ margin: 0, padding: theme.spacing(1) }}>
                    <Button onClick={() => setOpen(false)} variant='text' color='inherit'>Cancel</Button>
                    <Button variant='outlined' disabled={disableSave()} onClick={handleSubmit}>Submit</Button>
                </StickyDialogActions>
            </ResponsiveDialog>
        </>
    )
};

export default DisplayDialogContent;
